import { Box, Button, SxProps, Typography, useTheme } from '@mui/material';
import React from 'react';

export type DossierStatusStatCard = {
    statusIds: number[];
    libelle: string;
    count: number;
};

type DashboardStatCardPorps = {
    libelle: string;
    count: number;
    buttonText?: string;
    onClick?: (e: React.MouseEvent) => void;
    sxProps?: SxProps;
};
const DashboardStatCard: React.FunctionComponent<DashboardStatCardPorps> = function ({
    libelle,
    count,
    buttonText = 'Voir',
    onClick = () => {},
    sxProps,
}) {
    const { palette } = useTheme();

    return (
        <Box
            sx={{
                width: '100%', // Width and height based on parent size
                height: '100%',
                backgroundColor: palette.background.paper,
                border: `1px solid ${palette.grey[200]}`,
                boxShadow: `0px 2px 2.5px 0px ${palette.grey[200]}`,
                borderRadius: '8px',
                padding: '4px 8px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                ...sxProps,
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="l2dh6">{count}</Typography>

                <Button
                    sx={{
                        border: `1px solid ${palette.grey[200]}`,
                        padding: '4px 8px ',
                        boxShadow: `0px 2px 2.5px 0px ${palette.grey[200]}`,
                        color: palette.grey[700],
                    }}
                    onClick={onClick}
                >
                    {buttonText}
                </Button>
            </Box>
            <Typography variant="l2dbodys">{libelle}</Typography>
        </Box>
    );
};

export default DashboardStatCard;
